import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useTrainingHistoryReport } from "../../hooks/useTrainingHistoryReport";
import { useDownloadTrainingHistoryReportCsv } from "../../hooks/useDownloadTrainingHistoryReportCsv";
import { trainingHistoryReportColumns } from "../TrainingHistoryReportColumns/TrainingHistoryReportColumns";
import TrainingHistoryReportFilters from "../TrainingHistoryReportFilters/TrainingHistoryReportFilters";
import { TrainingHistoryReportItem } from "../../api/fetchTrainingHistoryReport/types";

const columns = trainingHistoryReportColumns();

const TrainingHistoryReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useTrainingHistoryReport();

  const { loading: csvLoading, downloadCsv } =
    useDownloadTrainingHistoryReportCsv();

  return (
    <MainPageWrapper title="Training History Report">
      <TrainingHistoryReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />
      <DataTable<TrainingHistoryReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No training history found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default TrainingHistoryReportPage;
